import { t } from 'i18next';
import { z } from 'zod';

export const SettingsFormSchema = z
	.object({
		companyName: z
			.string({ message: t('elements.form.company.error')})
			.min(1, t('elements.form.company.error')),		
		companyTin: z
			.string({ message: t('elements.form.tin.error') })
			.min(1, t('elements.form.tin.error')),	
		legalAddress: z
			.string({ message: t('elements.form.legalAddress.error') })
			.min(1, t('elements.form.legalAddress.error')),
		phoneNumber: z
			.string({ message: t('elements.form.phone.error') })
			.min(1, t('elements.form.phone.error')),	
		website: z
			.string({ message: t('elements.form.website.error') })
			.min(1, t('elements.form.website.error')),	
		bankName: z
			.string({ message: t('elements.form.bank.error') })
			.min(1, t('elements.form.bank.error')),	
		swiftCode: z
			.string({ message: t('elements.form.swift.error') })
			.min(1, t('elements.form.swift.error')),	
		iban: z
			.string({ message: t('elements.form.iban.error') })
			.min(1, t('elements.form.iban.error')),		
		primaryColor: z
			.string({ message: t('elements.form.color.error1') })
			.regex(/^#([0-9A-Fa-f]{3}){1,2}$/, { message: t('elements.form.color.error2') }),
		darkMode: z
			.boolean(),
		logo: z
			.union([
				z.instanceof(File, { message: t('elements.form.logo.error') }),
				z.string().min(1, t('elements.form.logo.error')),
			])
			.optional(),
		hotelName: z
			.string({ message: t('elements.form.hotel.error') })
			.min(1, t('elements.form.hotel.error')),	
		reservationDaysBeforeToCancel: z	
			.number({ message: t('elements.form.reservationDaysBeforeToCancel.error') }),
		orderDaysBeforeToCancel: z
			.number({ message: t('elements.form.orderDaysBeforeToCancel.error') }),
		reservationDaysBeforeToEdit: z	
			.number({ message: t('elements.form.reservationDaysBeforeToEdit.error') }),
		orderDaysBeforeToEdit: z	
			.number({ message: t('elements.form.orderDaysBeforeToEdit.error') }),
		multiCurrency: z
			.boolean({ message: t('elements.form.multiCurrency.error') }),
		ordersEnabled: z
			.boolean({ message: t('elements.form.ordersEnabled.error') }),
		rentAnalyticsHiddenExpenseKeys: z.array(z.string()).default([]),
	});
